import React from 'react'
import { useSelector } from 'react-redux'
import { matchPath } from 'react-router'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import AppName from 'src/components/AppName/AppName'
import PermanentPromotionBox from 'src/components/PermanentPromotionBox/PermanentPromotionBox'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import { useTranslate } from 'src/localization/Trns'
import { homeUrl, registerAccountUrl } from 'src/navigation/urls'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

interface AddAnotherAccountPermanentPromotionBoxProps {
  className?: string
  dismissPromo?: () => void
}

const AddAnotherAccountPermanentPromotionBox: React.FC<
  AddAnotherAccountPermanentPromotionBoxProps
> = (props): React.ReactElement => {
  const translate = useTranslate()

  const { analytics } = useAnalyticsContext()
  const accountImage = useColorOrGrayscaleImage(ImageNames.Account)
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  return (
    <PermanentPromotionBox
      imageSrc={accountImage}
      id="addAnotherAccountPopUpClose"
      title={translate('Add another account')}
      subtitle={translate(
        'If you have another corporate card to register with ${appName}, add another account to start using it.',
        {
          appName: <AppName />,
        },
      )}
      navAway={{
        id: 'regAcc',
        label: translate('Register an account'),
        to: registerAccountUrl(),
        ariaLabelSource: 'Register an account',
      }}
      onClick={(): void => {
        matchPath(calculatedBackgroundLocation.pathname, homeUrl()) &&
          analytics?.track('home - register an account - button press', {
            screen: homeUrl(),
            interaction: 'button press',
            intent: 'register an account',
          })
      }}
      dismissPromo={props.dismissPromo}
      usePlus
    />
  )
}

export default AddAnotherAccountPermanentPromotionBox
